import classNames from 'classnames'
import { ScripDetail } from '../../types/TINStocksSummaryHoldingsData'
import { formatNumberToINRCommaSeparatedString } from '@/root/utils/common/numbers/format-number-to-string'
import { useState } from 'react'
import AppOnlyFeature from '@/stories/components/AppOnlyFeatureModal'

export default function MyHoldingTickers({
  summary_for_tickers,
  livePriceArr,
}: {
  summary_for_tickers?: ScripDetail[]
  livePriceArr?: Record<
    string,
    | {
        price: number | undefined
        percChange: number | undefined
      }
    | undefined
  >
}) {
  const [showAppOnlyFeatureModal, setshowAppOnlyFeatureModal] = useState(false)
  const prevCloseArr = summary_for_tickers?.reduce((acc, curr) => {
    return {
      ...acc,
      [curr.metadata?.socket_path ?? '']: curr.metadata?.previous_close ?? 0,
    }
  }, {})

  const holdingsValue =
    summary_for_tickers?.reduce((acc, item) => {
      let holdingValue = acc
      holdingValue =
        acc +
        (item.holdings?.quantity ?? 0) *
          (livePriceArr?.[item.metadata?.socket_path ?? '']?.price ??
            item.metadata?.live_price ??
            0)
      return holdingValue
    }, 0) ?? 0

  const prevDayHoldingsValue =
    summary_for_tickers?.reduce((acc, item) => {
      let holdingValue = acc
      holdingValue =
        acc +
        (item.holdings?.quantity ?? 0) *
          (prevCloseArr?.[item.metadata?.socket_path ?? ''] ?? 0)
      return holdingValue
    }, 0) ?? 0

  const oneDayReturnTick = holdingsValue - prevDayHoldingsValue

  return (
    <div>
      {showAppOnlyFeatureModal && (
        <AppOnlyFeature
          showModal={showAppOnlyFeatureModal}
          onClose={() => setshowAppOnlyFeatureModal(false)}
        />
      )}
      <div
        className={classNames(
          'bg-brand-white shadow-one relative gap-1 rounded-t-xl px-4 py-2',
        )}
      >
        <div className="flex w-full items-center justify-between">
          <div>
            <div
              className={classNames(
                'bg-brand-white inline-flex items-center gap-2 py-1 text-sm ',
              )}
            >
              <span>1D Holdings Returns</span>
            </div>
            <div
              className={classNames('mt-1 text-xl', {
                'text-brand-green-dark': oneDayReturnTick > 0,
                'text-brand-red-cinnabar': oneDayReturnTick < 0,
              })}
            >
              {oneDayReturnTick > 0 ? '+' : ''}
              {formatNumberToINRCommaSeparatedString(oneDayReturnTick)}
            </div>
          </div>
        </div>
      </div>
      <div className="bg-brand-tertiary-blue shadow-one flex justify-between rounded-b-xl px-3 py-1">
        <span className="text-brand-grey-base text-sm">
          Share your portfolio & earn
        </span>
        <span
          onClick={() => setshowAppOnlyFeatureModal(prev => !prev)}
          className="text-brand-blue-azureRadiance cursor-pointer text-sm"
        >
          Share
        </span>
      </div>
    </div>
  )
}
